import { render, staticRenderFns } from "./OrderPages.vue?vue&type=template&id=4db2ec2a&scoped=true"
import script from "./OrderPages.vue?vue&type=script&lang=js"
export * from "./OrderPages.vue?vue&type=script&lang=js"
import style0 from "./OrderPages.vue?vue&type=style&index=0&id=4db2ec2a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db2ec2a",
  null
  
)

export default component.exports